<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.AUDIT.TEXT' | translate"
                      [items]="[('systemLogsCatalog.breadcrumb' | translate)]" />
    </div>

    <div class="system-log-workspace">
      <app-master-table
        [title]="'systemLogsCatalog.title' | translate"
        [dataSource]="dataSource"
        [columnDefinitions]="columnDefinitions"
        [actions]="actions"
        [filters]="tableFilters"
        [isLoading]="isLoading"
        [enableRowClick]="true"
        [disableRowClickToEdit]="true"
        [rowClickSelection]="false"
        [showContextMenu]="false"
        [useServerData]="true"
        [totalItems]="totalItems"
        [currentPage]="currentPage"
        [pageSize]="pageSize"
        [pageSizeOptions]="[25, 50, 100, 200]"
        [tableMaxHeight]="'100%'"
        [searchValue]="searchValue"
        [exportFileName]="'system-audit-logs'"
        (rowClick)="viewDetail($event)"
        (details)="viewDetail($event)"
        (refresh)="loadData()"
        (searchChange)="onSearchChange($event)"
        (filtersChange)="onFiltersChange($event)"
        (pageChange)="onPageChange($event)" />
    </div>
  </div>
</section>
